import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_ServiceTerminationChangeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_ServiceTerminationChangeSummary' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'><center><h4>Service Termination/Change Summary</h4></center>
                </p>

                <table>
                    <tr> 
                        <td className='w-375'> <span className='eleHeader'>ID Number:</span> </td> 
                        <td className='w-375'> <span className='eleHeader'>Effective Date of Service Change/Termination:</span> </td>
                    </tr>
                    <tr> 
                        <td className='w-375'> <input type='text' id='txtIdNumber' name='txtIdNumber' className='add-only' /> </td> 
                        <td className='w-375'> <input type='date' id='txtDateTermination' name='txtDateTermination' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServiceTermination' name='cbServiceTermination' className='add-only' value='Service Termination' /> Service Termination </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbServiceChange' name='cbServiceChange' className='add-only' value='Service Change' /> Service Change
                        </td>
                    </tr> 
                </table>

                <p className='w-750'> <span className='eleHeader'>Service Termination or Change is expected to be </span></p>

                <p className='w-375'>
                    <input type='checkbox' id='cbTemporary' name='cbTemporary' className='add-only' value='Temporary' /> Temporary &nbsp;
                    <input type='checkbox' id='cbPermanent' name='cbPermanent' className='add-only' value='Permanent' /> Permanent
                </p>

                <p className='w-750'> <span className='eleHeader'>Reasons for Service Termination/ Change (Check all that apply): </span></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInDiagnosis' name='cbChangeInDiagnosis' className='add-only' value='Change in Diagnosis' /> Change in Diagnosis </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInSymptoms' name='cbChangeInSymptoms' className='add-only' value='Change in Symptoms' /> Change in Symptoms </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInServiceActivities' name='cbChangeInServiceActivities' className='add-only' value='Change in Service Activities' /> Change in Service Activities
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentRecommendations' name='cbTreatmentRecommendations' className='add-only' value='Change in Treatment Recommendations' /> Change in Treatment Recommendations </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIntensiveService' name='cbIntensiveService' className='add-only' value='Appropriate for Less Intensive Service' /> Appropriate for Less Intensive Service </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInServiceStaff' name='cbChangeInServiceStaff' className='add-only' value='Change in Service Staff' /> Change in Service Staff
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeOther' name='cbChangeOther' className='add-only' value='Other' /> Other: 
                            <input type='text' id='txtChangeOther' name='txtChangeOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>List Service(s) Discontinued </span>
                    <textarea id='txtDiscontinued' name='txtDiscontinued' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>List Service(s) Initiated </span>
                    <textarea id='txtInitiated' name='txtInitiated' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Service Change Instructions or Information: </span>
                    <textarea id='txtInstructions' name='txtInstructions' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Signature/Credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}







